import { h, Fragment } from 'preact';
import { useContext } from 'preact/hooks';
import { addBundleToCart } from '../utils/bundleActions';
import { ItemsContext } from './ItemsProvider';

const AddToCartButton = ({ helpText }) => {
  const { state, dispatch } = useContext(ItemsContext);
  const { isLoading } = state;

  const initAddToCart = async () => {
    dispatch({
      type: 'ADD_BUNDLE_TO_CART',
    });
    try {
      await addBundleToCart(state);
      dispatch({
        type: 'ADD_BUNDLE_TO_CART_SUCCESS',
      });
    } catch (err) {
      console.error('something went wrong...');
      console.error(err);
    }
  };

  return (
    <Fragment>
      <button
        className="bundle-atc"
        onClick={initAddToCart}
        disabled={isLoading || !state.bundle.product.available}
      >
        {isLoading ? (
          <Fragment>loading...</Fragment>
        ) : (
          <Fragment>
            {!state.bundle.product.available ? (
              <Fragment>SOLD OUT</Fragment>
            ) : (
              <Fragment>ADD BUNDLE TO CART</Fragment>
            )}
          </Fragment>
        )}
      </button>
      <p className="bundle-atc__help">{helpText}</p>
    </Fragment>
  );
};

export default AddToCartButton;
